import React from 'react';
import { Sparkles, CheckCircle2, FileCheck, Heart, MessageCircle, Flower2 } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Elegant dark funeral-themed background */}
      <div className="absolute inset-0 bg-gradient-to-br from-funeral-dark via-funeral-secondary to-black"></div>
      
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(201, 169, 97, 0.1) 10px, rgba(201, 169, 97, 0.1) 20px)`
      }}></div>
      
      {/* Subtle decorative elements */}
      <div className="absolute top-20 left-10 text-funeral-gold/10 animate-pulse">
        <Sparkles size={40} />
      </div>
      <div className="absolute bottom-20 right-10 text-funeral-gold/10 animate-pulse" style={{ animationDelay: '1s' }}>
        <Sparkles size={40} />
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center py-20">
        <div className="mb-12 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-funeral-gold/20 blur-3xl rounded-full"></div>
            <Flower2 className="relative text-funeral-gold animate-pulse" size={80} strokeWidth={1.5} />
          </div>
        </div>
        
        <h1 className="text-6xl md:text-8xl font-serif font-light text-funeral-gold mb-8 tracking-wide">
          Kenangan.AI
        </h1>
        <div className="divider mb-8"></div>
        <p className="text-2xl md:text-3xl text-funeral-light mb-6 font-light flex items-center justify-center gap-3">
          <MessageCircle size={28} className="text-funeral-gold" />
          Layanan Artificial Intelligence berbasis WhatsApp
        </p>
        <div className="max-w-3xl mx-auto space-y-3 text-funeral-light mb-12 text-lg">
          <p>Membantu keluarga menyampaikan informasi duka.</p>
          <p>Membantu tamu mengirim narasi doa, pesan, foto, dan video.</p>
          <p>Semua dikompilasi menjadi kenangan untuk keluarga.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-14">
          <div className="flex items-center gap-3 text-funeral-gold bg-funeral-secondary/50 px-6 py-3 rounded-full border border-funeral-gold/30 hover:border-funeral-gold/60 transition-all text-lg">
            <CheckCircle2 size={24} />
            <span>Praktis</span>
          </div>
          <div className="flex items-center gap-3 text-funeral-gold bg-funeral-secondary/50 px-6 py-3 rounded-full border border-funeral-gold/30 hover:border-funeral-gold/60 transition-all text-lg">
            <FileCheck size={24} />
            <span>Rapi</span>
          </div>
          <div className="flex items-center gap-3 text-funeral-gold bg-funeral-secondary/50 px-6 py-3 rounded-full border border-funeral-gold/30 hover:border-funeral-gold/60 transition-all text-lg">
            <Heart size={24} />
            <span>Menguatkan</span>
          </div>
        </div>

        <a 
          href="#contact" 
          className="inline-flex items-center gap-3 bg-funeral-gold text-funeral-dark px-10 py-4 rounded-sm font-medium hover:bg-funeral-gold/90 transition-all hover:scale-105 shadow-lg hover:shadow-funeral-gold/20 text-lg"
        >
          <MessageCircle size={24} />
          Hubungi Kami
        </a>
      </div>
    </section>
  );
};

export default Hero;
